import { useQuery } from "@tanstack/react-query";
import { AnalyticsService } from "@/services/analytics/AnalyticsService";

export const useUserGenieAnalytics = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["user-genie-analytics", userId],
    queryFn: () => AnalyticsService.getAgentAnalytics({ filterByUserId: userId }),
    enabled: !!userId,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
  });
};
